import styled from 'styled-components';

export const StyledNav = styled.div`
  display: flex;
  flex: auto 0;
  width: ${(p) => p.theme.space[8]};
  height: 100%;
  padding: ${(p) => p.theme.space[3]} ${(p) => p.theme.space[0]};
  box-shadow: ${(p) => p.theme.shadows.left};
  align-items: center;
  flex-direction: column;
  position: fixed;

  // Hidden scroll bar but scrollable
  overflow: hidden scroll;
  scrollbar-width: none; // firefox
  -ms-overflow-style: none; // ie 10+

  &::-webkit-scrollbar {
    display: none; // safari, chrome
  }
`;
